import { render } from "./OriginalPage.vue?vue&type=template&id=42df7572&scoped=true"
import script from "./OriginalPage.vue?vue&type=script&lang=js"
export * from "./OriginalPage.vue?vue&type=script&lang=js"

import "./OriginalPage.vue?vue&type=style&index=0&id=42df7572&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42df7572"]])

export default __exports__